import { Alert, Card, Stack } from "@mantine/core";
import useTransientStore from "../../../data/transcientStore";
import { useTranslation } from "../../../hooks/useTranslation";
import { usePermissions } from "../../../hooks/usePermissions";
import CityObjectYearReportPage from "../../../pages/cityObjectYearReport/CityObjectYearReportPage";
import { ReportSectionHeader } from "../ReportSectionHeader";

interface AnnualSummaryReportProps {
  onBack: () => void;
  showHeader?: boolean;
}

export default function AnnualSummaryReport({
  onBack,
  showHeader = true,
}: Readonly<AnnualSummaryReportProps>) {
  const selectedAddressSystemId =
    useTransientStore((state) => state.selectedAddressSystem?.id) ?? 0;
  const { getTranslation } = useTranslation({
    pageId: 515,
    addressSystemId: selectedAddressSystemId,
    autoLoad: true,
  });
  const { checkAccess } = usePermissions();

  if (!checkAccess("CITY_OBJECT_YEAR_REPORT")) {
    return (
      <Card withBorder radius="lg" px="xl" py="lg" shadow="sm">
        <Alert color="yellow">
          {getTranslation("REPORTS_NO_ACCESS") ||
            "You do not have permission to view this report."}
        </Alert>
      </Card>
    );
  }

  return (
    <Card withBorder radius="lg" px="xl" py="lg" shadow="sm">
      <Stack gap="md">
        {showHeader && (
          <ReportSectionHeader
            onBack={onBack}
            contextLabel={
              getTranslation("REPORTS_HUB_LABEL") || "Reports"
            }
            title={
              getTranslation("REPORTS_ANNUAL_SUMMARY") || "Annual summary"
            }
            backLabel={
              getTranslation("REPORTS_RETURN") || "Back to reports"
            }
          />
        )}

        <CityObjectYearReportPage />
      </Stack>
    </Card>
  );
}
